import * as React from "react"
import { cn } from "../../lib/utils"

function Badge({ className, variant = "muted", ...props }) {
  const variants = {
    // Light-tint variants (primary pattern for status/metadata labels)
    teal:    "bg-[var(--teal-3)] text-[var(--teal-11)] border-[var(--teal-6)]",
    blue:    "bg-[var(--blue-3)] text-[var(--blue-11)] border-[var(--blue-6)]",
    orange:  "bg-[var(--orange-3)] text-[var(--orange-11)] border-[var(--orange-6)]",
    purple:  "bg-[var(--purple-3)] text-[var(--purple-11)] border-[var(--purple-6)]",
    magenta: "bg-[var(--magenta-3)] text-[var(--magenta-11)] border-[var(--magenta-6)]",
    muted:   "bg-muted text-muted-foreground border-[var(--mauve-6)]",

    // Solid variants (high-emphasis)
    "solid-purple":  "bg-primary text-primary-foreground border-[color-mix(in_srgb,var(--color-primary)_80%,black)] font-semibold",
    "solid-magenta": "bg-[var(--magenta-9)] text-white border-[color-mix(in_srgb,var(--magenta-9)_80%,black)] font-semibold",

    // Utility variants
    secondary: "bg-secondary text-secondary-foreground border-[color-mix(in_srgb,var(--color-secondary)_80%,black)]",
    outline:   "text-foreground border-border",
  }

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        variants[variant],
        className
      )}
      {...props}
    />
  )
}

export { Badge }
